import { render, staticRenderFns } from "./c-card-view.vue?vue&type=template&id=0f9ec470&scoped=true&"
import script from "./c-card-view.vue?vue&type=script&lang=js&"
export * from "./c-card-view.vue?vue&type=script&lang=js&"
import style0 from "./c-card-view.vue?vue&type=style&index=0&id=0f9ec470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9ec470",
  null
  
)

export default component.exports